// extracted by mini-css-extract-plugin
export default {"light":"RedLight_light__J7RWj"};